import React from "react";
import Button from "../form/Button";

const EligibilityFailedContent = ({
  okHandler = () => {},
  onRetake = () => {},
  loading = false,
}) => {
  return (
    <>
      <div className="flex items-center justify-center gap-2 my-4">
        <div className="text-2xl text-chestnut-rose">
          <i className="fa-regular fa-fw fa-circle-xmark"></i>
        </div>
        <div className="text-2xl font-semibold font-CanelaDeck">Failed</div>
      </div>
      <div className="space-y-3 font-Gotham font-medium text-center">
        {/* <p>
          Thank you for taking the eligibility quiz. Based on your responses,
          you do not currently meet the requirements for the V’Peters Family
          Scholarship.
        </p>
        <p>
          We understand this may be disappointing, but it does not reflect on
          your abilities or future potential.
        </p>
        <p>
          If you believe there was an error, you may review the eligibility
          criteria and retake the quiz if applicable.
        </p> */}
        <p>
          Thank you! Based on your answers, you're not currently eligible. If
          you believe there was an error, you can retake the quiz.
        </p>
      </div>
      <div className="flex justify-center mt-4 gap-4 py-8">
        <Button
          buttonLabel={"Ok"}
          buttonFunction={() => {
            okHandler();
          }}
          buttonClasses="!h-10 xl:!h-12 !rounded-full !px-6 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white min-w-40"
          buttonLabelClasses="!text-base xl:!text-xl"
        />
        <Button
          buttonLabel={"Retake"}
          buttonFunction={onRetake}
          buttonClasses="!h-10 xl:!h-12 !rounded-full !px-6 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white min-w-40"
          buttonLabelClasses="!text-base xl:!text-xl"
          {...(loading && {
            buttonIcon:
              "fa-duotone fa-solid fa-spinner-third animate-spin !text-base xl:!text-xl",
            buttonIconPosition: "left",
            isDisable: true,
          })}
        />
      </div>
    </>
  );
};

export default EligibilityFailedContent;
